export enum GameMode {
  ModoSolo = 1,
  DailyDash = 2,
}
